import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-81c501e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Profesores Disponibles", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_3 = { class: "search-form" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = { class: "table-container" }
const _hoisted_6 = { class: "modern-table" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Nombre"),
    /*#__PURE__*/_createElementVNode("th", null, "País/Ciudad"),
    /*#__PURE__*/_createElementVNode("th", null, "Especialidad"),
    /*#__PURE__*/_createElementVNode("th", null, "Tarifa"),
    /*#__PURE__*/_createElementVNode("th", null, "Ver detalles")
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Juanjo", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "España (Málaga)", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Vue / Laravel", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "10€", -1))
const _hoisted_12 = { class: "link-add" }
const _hoisted_13 = { href: "/profesores-detalles" }

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import {ref} from 'vue'
import main from '@/data/main.js';



export default /*#__PURE__*/_defineComponent({
  __name: 'TeachersView',
  setup(__props) {

const search = ref('')

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("form", _hoisted_3, [
        _createVNode(_component_v_icon, { name: "fa-filter" }),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          placeholder: "Escribe aquí para filtrar.",
          class: "input-job"
        }, null, 512), [
          [_vModelText, search.value]
        ])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("a", _hoisted_13, [
                  _createVNode(_component_v_icon, {
                    name: "md-fileopen-round",
                    class: "ver",
                    fill: _unref(main).SECONDARY_COLOR,
                    scale: "2"
                  }, null, 8, ["fill"])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})